import React from "react";
import PropTypes from "prop-types";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		marginTop: "12px",
		display: "flex",
		alignItems: "center",
	},
	howTo: {
		fontFamily: theme.fonts.medium,
		fontSize: "14px",
		lineHeight: "1.36",
		letterSpacing: "2px",
		color: theme.palette.colors.purplishBlue,
		// width: "151px",
		marginRight: "auto",
		textTransform: "uppercase",
		cursor: "pointer",
	},
	buttons: {
		"& > div": {
			display: "inline-block",
		},
	},
	firstButton: {
		marginRight: "20px",
		width: "auto",
	},
	secondButton: {
		width: "auto",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		buttons: {
			"& > div": {
				fontSize: "14px",
			},
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			marginTop: "18px",
			display: "flex",
			alignItems: "flex-start",
			justifyContent: "center",
			flexWrap: "wrap",
		},
		howTo: {
			fontSize: "12px",
			lineHeight: "1.58",
			letterSpacing: "1.7px",
			width: "100%",
			marginRight: "0",
			textAlign: "center",
			marginBottom: "21px",
		},
		buttons: {
			textAlign: "center",
		},
		firstButton: {
			marginRight: "10px",
			width: "auto",
		},
		secondButton: {
			width: "auto",
		},
	},
	"@media (max-width: 520px)": {
		root: {
			marginTop: "18px",
			display: "flex",
			alignItems: "flex-start",
			justifyContent: "center",
			flexWrap: "wrap",
		},
		howTo: {
			fontSize: "12px",
			lineHeight: "1.58",
			letterSpacing: "1.7px",
			width: "100%",
			marginRight: "0",
			textAlign: "center",
			marginBottom: "21px",
		},
		buttons: {
			textAlign: "center",
		},
		firstButton: {
			marginRight: "0px",
			marginBottom: "10px",
			width: "auto",
		},
		secondButton: {
			width: "auto",
		},
	},
});
const ButtonsRowRating = ({
	classes,
	howTo,
	firstButton,
	secondButton,
	onClick,
	datatestHowTo,
}) => {
	return (
		<div className={classes.root}>
			<div className={classes.howTo} onClick={onClick} datatest={datatestHowTo}>
				{howTo}
			</div>
			<div className={classes.buttons}>
				<div disabled className={classes.firstButton}>
					{firstButton}
				</div>
				<div disabled className={classes.secondButton}>
					{secondButton}
				</div>
			</div>
		</div>
	);
};

ButtonsRowRating.defaultProps = {
	howTo: "",
	firstButton: null,
	secondButton: null,
	datatestHowTo: null,
};

ButtonsRowRating.propTypes = {
	howTo: PropTypes.string.isRequired,
	firstButton: PropTypes.any.isRequired,
	secondButton: PropTypes.any.isRequired,
};

export default withStyles(styles)(ButtonsRowRating);
